import { colors } from './../../variables';
import styled, { css } from "styled-components";
import { RouteComponentProps, withRouter } from 'react-router-dom';

export const HeaderWrapper = styled.header`
  height: 50px;
  /* background-color: ${colors.back}; */
  position: relative;
  padding-left: 40px;
  padding-top: 40px;
  align-items: center;
  display: flex;
  @media (max-width: 991px){
    text-align: center;
    display: block;
    padding-left: 0px;
    padding-top: 15px;
    height: auto;
  }
  @media (max-width: 767px){
    height: auto;
  }
`;

const _Logo = styled.img<RouteComponentProps>`
  width: 150px;
  height: auto;
  position: fixed;
  left: 20px;
  top: 0px;
  color: #000;
  text-transform: uppercase;
  font-style: italic;
  margin-right: 20px;
  @media (max-width: 991px){
    width: 120px;
    position: relative;
    top: inherit;
    z-index: 2;
    left: inherit;
    text-align: center;
    margin: 0 auto;
    top: 0px;
  }
  ${props => (
    props.match.path.startsWith('/test2') ||
    props.match.path.startsWith('/test')
  ) && css`
    @media (max-width: 991px){
      filter: invert(1);
    }
    
  `
  }
`;

const _Catchline = styled.h1<RouteComponentProps>`
  position: relative;
  font-size: 28px;
  font-weight: 400;
  color: #000;
  position: fixed;
  left: 190px;
  top: 42px;
  display: none;
  br{
    display: none;
    @media (max-width: 991px){
      display: block;
    }
  }
  span{
    font-size: 32px;
  }
  @media (max-width: 991px){
    position: relative;
    text-align: center;
    left: inherit;
    font-size: 28px;
    margin-top: 0px;
    top: 10px;
    position: relative;
    padding: 0px 20px;
    top: 0px;
    margin-bottom: 30px;
  }

  ${props => (
    props.match.path.startsWith('/message')||
    props.match.path.startsWith('/end')||
    props.match.path.startsWith('/upload')
  ) && css`
    display: block;
    
  `
  }

${props => (
    props.match.path.startsWith('/record')
  ) && css`
  display: block;
    @media (max-width: 767px){
    display: block;
  }
    
  `
  }

${props => (
    props.match.path.startsWith('/message')
  ) && css`
    @media (max-width: 767px){
    color: #000;
  }
    
  `
  }

${props => (
    props.match.path.startsWith('/preview') ||
    props.match.path.startsWith('/upload') ||
    props.match.path.startsWith('/end')
  ) && css`
    @media (max-width: 991px){
      display: none;
    }
    
  `
  }
`;

export const Catchline = withRouter(_Catchline);
export const Logo = withRouter(_Logo);